import React from 'react';
import styled from 'styled-components';

import { FormattedDecimal } from '../content/numbers.component';

const Container = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;

  @media(min-width: 1000px) {
      gap: 1rem;
  }
`

const Input = styled.input`
  padding: 3px 5px;

  @media(max-width: 1000px){
    width: 50%;
    font-size: var(--mini-mobile-size);
  }
`

const InputsWrapper = styled.div`
   display: flex;
   gap: 0.5rem;
   order: 1;

  @media(min-width: 1000px) {
      gap: 1rem;
      order: 0;
  }
`

const Balance = styled.span`
  display: block;
  font-size: var(--title-size);
  margin-right: 50px;

  @media(max-width: 1000px) {
    margin-right: 0;
  }
`

export const FilterTableRow = (props) => {

  return (
    <Container>
      <InputsWrapper>
        <Input placeholder="Filtruj po firmie" onChange={e => {
          props.setCompany(e.target.value);
        }} />
        <Input placeholder="Filtruj po roku wystawienia" onChange={e => {
          props.setYear(e.target.value);
        }}/>
      </InputsWrapper>
      <Balance>Saldo: <b><FormattedDecimal value={props.balance} color="true" /></b> zł</Balance>
    </Container>
  )
}